import expiringLocalStorage from "@/app/services/expiringLocalStorage";
import { isKioskMode } from "@/app/utils/kioskManager";

const STORAGE_KEY = "lnow_algolia_user_token";
const WAREHOUSE_KEY = "lansingnow_geolocated_warehouse";

function generateUUID(): string {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export function getAnonymousUserToken(): string {
  if (isKioskMode()) {
    const warehouseCode = expiringLocalStorage.getItem(WAREHOUSE_KEY);
    if (warehouseCode) {
      return `anon-kiosk-${warehouseCode}`;
    }
  }

  let token = localStorage.getItem(STORAGE_KEY);
  if (!token) {
    token = "anon-" + generateUUID();
    localStorage.setItem(STORAGE_KEY, token);
  }
  return token;
}
